import { PropsWithChildren, useId } from "react";

import { cn } from "@bentolabs/kit/utils";
import { motion } from "motion/react";

import { TabsContext } from "./context";
import { TabsVariantProps, tabsVariants } from "./styles";

export const Tabs = (
  props: PropsWithChildren<
    { className?: string; activeElementClassName?: string } & TabsVariantProps
  >
) => {
  const {
    children,
    className,
    variant = "button",
    size = "38",
    color = "spearmint",
    activeElementClassName = "",
    ...restProps
  } = props;
  const lineLayoutId = useId();

  return (
    <motion.div
      layout
      layoutRoot
      {...restProps}
      className={cn(tabsVariants({ variant, size, color, className }))}
    >
      <TabsContext.Provider
        value={{
          lineLayoutId: lineLayoutId,
          color,
          variant,
          size,
          activeElementClassName,
        }}
      >
        {children}
      </TabsContext.Provider>
    </motion.div>
  );
};
